/* eslint-disable no-console */

import { register } from "register-service-worker";

// Auto-reload when new service worker takes control
let refreshing = false;
if (navigator.serviceWorker) {
  navigator.serviceWorker.addEventListener("controllerchange", function () {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready(registration) {
      console.log("[SW] App is served from cache by a service worker.");
      // Check for updates every 30 minutes
      setInterval(
        function () {
          console.log("[SW] Checking for service worker update...");
          registration.update();
        },
        30 * 60 * 1000
      );
    },
    registered(registration) {
      console.log("[SW] Service worker has been registered.", registration);
    },
    cached() {
      console.log("[SW] Content has been cached for offline use.");
    },
    updatefound() {
      console.log("[SW] New content is downloading...");
    },
    updated() {
      console.log("[SW] New content is available; auto-reloading...");
    },
    offline() {
      console.log(
        "[SW] No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("[SW] Error during service worker registration:", error);
    }
  });
}
